export default "__VITE_PUBLIC_ASSET__ab752566__"